import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import PayUi from './components/public/index.js';
import './assets/style/element-ui-theme/index.css';
import './assets/style/index.less';
import ElementUI from 'element-ui';
import Mixin from './mixins/index.js';
import Plugins from './util/plugins.js';
import echarts from 'echarts';


Vue.prototype.$echarts = echarts;
Vue.config.productionTip = false;
Vue.use(ElementUI);
Vue.use(PayUi);
Vue.use(Mixin);
Vue.use(Plugins);

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');
